import { render, staticRenderFns } from "./pbl2.vue?vue&type=template&id=30e33cd7&scoped=true&"
import script from "./pbl2.vue?vue&type=script&lang=js&"
export * from "./pbl2.vue?vue&type=script&lang=js&"
import style0 from "./pbl2.vue?vue&type=style&index=0&id=30e33cd7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e33cd7",
  null
  
)

export default component.exports